import React, { useState } from 'react';
import { useMapCanvas } from '../../contexts/MapCanvasContext';
import { ShapeOptions, ShapeState } from './ShapeProvider.types';

export const ShapeContext = React.createContext<ShapeState | null>(null);

export const ShapeProvider: React.FC<React.PropsWithChildren<ShapeOptions>> = ({
  children,
  ...options
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [snapLines, setSnapLines] = useState<{ x?: number; y?: number }>({});
  const [image, setImage] = useState<HTMLImageElement | null>(null);

  const { isViewMode } = useMapCanvas();

  if (isViewMode) options.shape.locked = false;

  return (
    <ShapeContext.Provider
      value={{
        isHovered,
        isEditing,
        snapLines,
        image,
        setIsHovered,
        setIsEditing,
        setSnapLines,
        setImage,
        ...options
      }}
    >
      {children}
    </ShapeContext.Provider>
  );
};
